import React, { useId, useMemo } from "react";
import styled from "styled-components/macro";

import Stack from "../../../components/Stack";
import { useSentEstateItems } from "../../../hooks/useSentEstateItems";
import { estateItemShortLabel } from "../../../shared/probateEstate/estateItemTypes";
import { itemsOfTypes } from "../../../shared/probateEstate/ledger";
import Asset, { AssetList } from "./Asset";

const ListLabel = styled.p`
  margin: 0;
  font-weight: var(--juno-font-weight-bold);
`;

const NoneYet = styled.p`
  margin: 0;
  font-size: var(--text-sm);
  line-height: var(--text-sm--line-height);
  color: var(--muted-foreground);
`;

// The case's estate items of the given types, read only: the ledger's, then any the client has
// sent that the staff app hasn't sent back yet. The ledger doesn't say which document an item came
// from, so no item names one yet.
const EstateItemList = ({ kase, types, label }) => {
  const labelId = useId();
  const sent = useSentEstateItems(kase);
  const items = useMemo(
    () => [...itemsOfTypes(kase.ledger, types), ...sent.filter((item) => types.includes(item.item_type))],
    [kase, types, sent],
  );

  return (
    <Stack gap="xs">
      <ListLabel id={labelId}>{label}</ListLabel>
      {items.length === 0 ? (
        <NoneYet>None yet.</NoneYet>
      ) : (
        <AssetList aria-labelledby={labelId}>
          {items.map((item) => (
            <Asset
              key={item.id}
              name={item.institution_name ?? item.description}
              type={estateItemShortLabel(item.item_type)}
              reference={item.reference}
            />
          ))}
        </AssetList>
      )}
    </Stack>
  );
};

export default EstateItemList;
